import { Injectable } from '@angular/core';
import { OfficeHomePageErrorHandler } from '../../error-handler/error-handler.service';
import { ErrorId } from '../../error-handler/error-id';
import { InstrumentationParam, InstrumentationParams, InstrumentationService, KnownInstrumentationEvents } from '../instrumentation/instrumentation.service';
import { FileType } from '../models/file-item.model';
import { OneDriveGraphService } from './onedrive-graph.service';

@Injectable({
    providedIn: 'root'
})
export class CreatePlaylistService {
    private oneDriveUrl: string;

    public constructor(
        private readonly globalErrorHandler: OfficeHomePageErrorHandler,
        private readonly oneDriveGraphService: OneDriveGraphService,
        private readonly instrumentationService: InstrumentationService) {
        }

    public async handlePlaylistCreation(correlationId: string, fileType: FileType): Promise<void> {
        try {
            // Set OneDrive URL. If it fails or is not available, we will still try to fetch
            // it through UPA like before.
            const rootUrls = await this.oneDriveGraphService.getMyDriveRootUrl();
            const userRoot = rootUrls && rootUrls.userRoot;
            if (userRoot) {
                const documentsIndex = userRoot.lastIndexOf('/Documents');
                    if (documentsIndex === -1) {
                        this.instrumentationService.logErrorEvent(
                            KnownInstrumentationEvents.OneDriveUserRootUrl,
                            this.createWacContentInstrumentationParams(correlationId, fileType));
                        this.globalErrorHandler.handleError('userRootUrl not in expected format', ErrorId.sCtl9);
                    }

                this.oneDriveUrl = userRoot.substring(0, documentsIndex);
                const href = this.oneDriveUrl + '/_layouts/15/Lists.aspx?&openCreate=true&workload=Stream&cid=' + correlationId;
                window.open(href, '_blank');
            }
        } catch (err) {
            this.instrumentationService.logErrorEvent(
                KnownInstrumentationEvents.NewPlaylistButtonClick,
                this.createWacContentInstrumentationParams(correlationId));
            return this.globalErrorHandler.handleError(err, ErrorId.sCtl9);
        }
    }

    private createWacContentInstrumentationParams(
        correlationId: string,
        fileType?: FileType
    ): InstrumentationParams {
        if (fileType) {
            return {
                [InstrumentationParam.ResourceId]: correlationId,
                [InstrumentationParam.DocumentType]: FileType[fileType]
            };
        }

        return {
            [InstrumentationParam.ResourceId]: correlationId
        };
    }
}
